export const _amrMimeTypes = ["audio/amr", "audio/amr-wb", "audio/amr-wb+"];
